import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      poster={`https://assets-imgx.fubo.tv/marketing/lp/images/posters/LA_NBA_LP_Web.jpg`}
      posterMobile={`https://assets-imgx.fubo.tv/marketing/lp/images/posters/LA_NBA_LP_Mobile.jpg`}
      title="Mira la NBA en vivo en español"
      subtitle={`Más de ${laChannelCount} canales con deportes, noticias, novelas y entretenimiento en español.`}
      networkSet="entertainmentLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/nba/"
      sportId={sportIds.Basketball}
      leagueId={leagueIds.NBA}
    />
  )
}
